import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Check, X } from 'lucide-react';
import styles from './ProjectPublishedBanner.module.scss';

const AUTO_DISMISS_MS = 12000;

/**
 * One-shot success banner shown immediately after publishing a media project.
 */
const ProjectPublishedBanner = ({ onDismiss }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onDismiss) {
        onDismiss();
      }
    }, AUTO_DISMISS_MS);

    return () => clearTimeout(timer);
    // Auto-dismiss once on mount; ignore onDismiss identity changes from parent.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) {
    return null;
  }

  const handleDismiss = () => {
    setVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className={styles.banner} role="status">
      <span className={styles.iconWrap} aria-hidden>
        <Check size={14} strokeWidth={3} />
      </span>
      <p className={styles.message}>
        <strong className={styles.bold}>Project published.</strong>{' '}
        <span className={styles.detail}>
          We&apos;re finishing the full-quality version — clients will see it in
          a minute or two.
        </span>
      </p>
      <button
        type="button"
        className={styles.dismiss}
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        <X size={16} strokeWidth={2} aria-hidden />
      </button>
    </div>
  );
};

ProjectPublishedBanner.propTypes = {
  onDismiss: PropTypes.func,
};

export default ProjectPublishedBanner;
